<div style="max-height: 600px; padding-bottom: 48px;">
    <canvas baseChart width="700" height="500"
        chartType="line"
        [colors]="chartColors"
        [datasets]="chartData"
        [labels]="chartLabels"
        [legend]="chartLegend"
        [options]="chartOptions"
        [plugins]="chartPlugins">
    </canvas>

    <button mat-button
        mat-raised-button
        color="primary"
        (click)="randomizer()">
        Randomize
    </button>
</div>
